import React, { useEffect, useState } from 'react';
import "./SidebarChat.css";
import { Avatar } from '@mui/material';
import axios from "./axios";
import { Link } from 'react-router-dom';
function SidebarChat({id,name,image,addNewChat}) {
  const [seed,setSeed]=useState("");
  useEffect(()=>{
      setSeed(Math.floor(Math.random()*5000))
  },[])

  const createChat =()=>{
    const roomName=prompt("Please enter name for chat")
    if(roomName){
      //do some clever stuff
      axios.post("/rooms/new",{
        name:roomName,
      })


    }
  }
  return !addNewChat ? (
    <Link to={`/rooms/${id}`}>
    <div className='sidebarChat'>
        <Avatar src={`https://api.dicebear.com/6.x/adventurer/svg?seed=${seed}&scale=150`} />
        <div className="sidebarChat_info">
            <h2>{name}</h2>
            <p>Chats.....</p>
        </div>
    </div>
     </Link>
  ):(
    <div onClick={createChat} className="sidebarChat">
      <h2>Add new Chat</h2>
    </div>
   
  )
}

export default SidebarChat